var ApplicantAPI = require("../../common/api/applicant");
var AuthStore = require("../../common/auth")
var AuthAPI = require('../../common/api/auth');

module.exports = function ApplicantRegistrationConfirmedController($scope, $state, ngDialog) {
  var vm = this;

    //register that questions have been filled out with server
    ApplicantAPI.registerQuestionsCompleted().then(function(){

      AuthStore.refresh(function(){
        //on 200 from server redirect app to public.applicantRegistration
        $state.go('public.applicantRegistration');
      });

    })

};
